import { flatten, qsCommaParamsSerializer } from '@higo/api/src/utils/axios';
import { SecuredFileResourceDTO } from '@higo/api/src/models/fileResourceDTO';
import { AxiosInstance } from 'axios';
import { FileAccessLinkExtendedDTO } from '@higo/api/src/models/fileAccessLinkExtendedDTO';
import { ListWrapperDTO, unwrap } from '@higo/api/src/ext/listWrapper';

export const fetchFile = (axios: AxiosInstance) => (fileId?: number) =>
  axios.get<SecuredFileResourceDTO>(`api/files/${fileId}/link`).then(flatten);

export const fetchFiles =
  (axios: AxiosInstance) => async (fileIds: number[], rawAudio?: boolean) => {
    const CHUNK_SIZE = 50;

    if (!fileIds || fileIds.length === 0) return [] as FileAccessLinkExtendedDTO[];

    const makeRequest = (ids: number[]) =>
      axios
        .get<ListWrapperDTO<FileAccessLinkExtendedDTO>>(`api/v2/files/links`, {
          params: { fileIds: ids, rawAudio: [rawAudio] },
          paramsSerializer: qsCommaParamsSerializer,
        })
        .then(flatten)
        .then(unwrap);

    if (fileIds.length <= CHUNK_SIZE) {
      return makeRequest(fileIds);
    }

    const chunks: number[][] = [];
    for (let i = 0; i < fileIds.length; i += CHUNK_SIZE) {
      chunks.push(fileIds.slice(i, i + CHUNK_SIZE));
    }

    const settled = await Promise.allSettled(chunks.map(makeRequest));
    const fulfilled = settled
      .filter((r): r is PromiseFulfilledResult<FileAccessLinkExtendedDTO[]> => r.status === 'fulfilled')
      .map((r) => r.value);
    const rejected = settled.filter((r) => r.status === 'rejected');
    if (rejected.length) {
      console.warn(
        `[fetchFiles] ${rejected.length} chunk(s) failed while fetching file links`,
        rejected.map((r) => (r as PromiseRejectedResult).reason),
      );
    }
    return fulfilled.flat();
  };
